import React__default from 'react';
import clsx from 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import BrowseButton from '../components/BrowseButton/BrowseButton.js';
import '../../buttons/index.js';
import './../../../assets/src/components/file-uploadV2/components/ProcessingZone/ProcessingZone.css.ts.vanilla-36b1cf63.css';
import { cssCloudImage } from '../index.css.js';
import activeCloudImage from './active-cloud-computing.png.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const UploadDropzoneComponent = ({ type, fileBrowseTitle, dragDropTitle, dropzoneClass, classes = {}, disabled, getRootProps, getInputProps, open }) => {
    const isCondensed = type === 'condensed';
    const isLarge = type === 'large';
    const isSimple = type === 'simple';
    return (React__default.createElement("div", { ...getRootProps(), className: !isSimple ? clsx(dropzoneClass, classes.dropzone) : classes.dropzone },
        React__default.createElement(Visible, { when: isLarge },
            React__default.createElement("img", { className: clsx('c-cloud-image', classes.image, cssCloudImage), src: activeCloudImage })),
        React__default.createElement("input", { "data-testid": 'upload-file-input', ...getInputProps() }),
        React__default.createElement(Visible, { when: !isSimple },
            React__default.createElement("div", { "data-testid": 'dropzone-title', className: clsx('c-dropzone__title', isCondensed && 'c-dropzone__title--condensed', classes.title) }, dragDropTitle)),
        React__default.createElement(BrowseButton, { title: fileBrowseTitle, onClick: open, classes: classes, disabled: disabled, isDropzoneCondensed: isCondensed })));
};

export { UploadDropzoneComponent as default };
//# sourceMappingURL=UploadDropzoneComponent.js.map
